import React from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'

import { useNavigate } from '@lib/react-router-dom'

import { useSessionEntity } from '@context/EntityContext'
import { useModal } from '@context/ModalsContext'
import { useSessionLanguage } from '@context/SessionSettingsContext'

import { Body1, Heading4 } from '@ui/Typography'
import { Modal } from '@ui/components/Modal'

import { useApiClient } from '@utils/ApiClient'
import { ClientApiClient } from '@utils/clientApi'

import { useScrollToTop } from '@hooks/useScrollToTop'

import { InformationModal } from '@shared/modals/Information.modal'

import { ForgotPasswordForm, ForgotPasswordFormValues } from './ForgotPasswordForm'

import styles from './ForgotPasswordPage.module.scss'

export interface ForgotPasswordPageProps {
  storybook?: boolean
}

export const ForgotPasswordPage: React.FC<ForgotPasswordPageProps> = (props) => {
  useScrollToTop()

  const { t } = useTranslation()
  const apiClient = useApiClient(ClientApiClient)
  const navigate = useNavigate()
  const locale = useSessionLanguage()
  const entity = useSessionEntity()

  const passwordSentModal = useModal(InformationModal, {
    title: t('Password has been reset'),
    onClose: () => navigate('/login'),
  })

  const location = useLocation()

  const handleSubmit = async (values: ForgotPasswordFormValues) => {
    await apiClient.resetPassword({
      ...values,
      communicationLanguageId: locale,
    })
    const params = new URLSearchParams()
    if (!props.storybook) {
      params.append('email', values.email)
    }
    await apiClient.getResetPasswordAttempts(params)
    passwordSentModal.open({
      description: () => (
        <Modal.Body.Text
          dangerouslySetInnerHTML={{
            __html: `${t('We sent out the password reset e-mail')} (<b>${values.email}</b>) ${t(
              'to your address. Please follow the instructions on e-mail.'
            )}`,
          }}
        />
      ),
    })
  }

  return (
    <div className={styles.topWrapper}>
      <div className={styles.wrapper}>
        <div className={styles.inner}>
          <Heading4>{t('Forgot Password.Forgot Password')}</Heading4>
          <Body1 className={styles.helpText}>{t('Forgot Password.Sent Link')}</Body1>
          <ForgotPasswordForm
            entity={entity}
            onSubmit={handleSubmit}
            email={location?.state?.email}
          />
        </div>
      </div>
    </div>
  )
}
